import MicroModal from "micromodal";

export default function initModal() {
  MicroModal.init({
    openTrigger: 'data-open-modal', // [3]
    closeTrigger: 'data-close-modal', // [4]
  });
}

